module.exports = __webpack_public_path__ + "img/modi-top-img.d9efff70.png";